import { useEffect, useState } from 'react';

export default function useRedirectCountdown(seconds, url, { enabled = true } = {}) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (!enabled || !url) return undefined;

    if (remaining <= 0) {
      window.location.href = url;
      return undefined;
    }

    const timer = setTimeout(() => setRemaining(value => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining, url, enabled]);

  return remaining;
}
